import React from 'react';
import {Alert, Button} from "reactstrap";
import {faBoxesPacking} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

const QuoteReservesAlert = ({quote}) => {
    if (quote.reserve?.saturnReserveData == null)
        return;
    return (
        <Alert color="warning" className={"warning-badge"} >
            <h5 className="text-center mb-0 pb-0 mt-0 warning">
                <FontAwesomeIcon className={"me-2"} icon={faBoxesPacking}
                                 />
                RESERVED
                <FontAwesomeIcon className={"ms-2"} icon={faBoxesPacking}
                                 />
            </h5>
        </Alert>
    );
}
export default QuoteReservesAlert;
